import styled from 'styled-components'

import { Table as ComponentTable } from 'src/components/Ant'

export const Div = styled.div`
  width: 4px;
`

export const Status = styled.span`
  align-items: center;
  display: flex;
  justify-content: center;
`

export const Table = styled(ComponentTable)`
  border-radius: 4px;
  margin: 0 16px 24px 16px;
`

export const Integration = styled.div`
  color: royalblue;
  cursor: pointer;
  font-size: small;
  text-decoration: underline;
`
